// The range a chart covers: every reading, every limit drawn on it, and a little air.
//
// The limits are part of it on purpose. A chart scaled only to the readings puts the critical line
// off the top whenever the tyre is healthy - which is exactly when somebody wants to see how much
// room is left. Readings may be missing entirely, so this never reduces over an empty list.
const chartSpan = (readings, limits) => {
  const values = [...readings, ...limits].filter((v) => typeof v === 'number' && Number.isFinite(v));
  if (!values.length) return ['auto', 'auto'];
  const low = Math.min(...values);
  const high = Math.max(...values);
  const pad = Math.max(2, (high - low) * 0.12);
  return [Math.floor(low - pad), Math.ceil(high + pad)];
};

export default chartSpan;
